module.exports = __webpack_public_path__ + "static/FikaCakes-d691ce087675fe6933721ed2b4089220.webp";